import { useTranslation } from 'react-i18next';
import { useQueryClient } from '@tanstack/react-query';

import CardInfo from '../../../../components/card-info/CardInfo';
import { IGetInterventionResponse } from '../../../../api/assistance/assistance.types';
import { ProviderStyle } from './provider-style';

const Provider = () => {
  const queryClient = useQueryClient();

  const interventionData = queryClient.getQueryData<IGetInterventionResponse>(['interventionData']);
  const { t } = useTranslation(['aia']);

  return (
    <ProviderStyle>
      <CardInfo data={[{ title: t('aia:provider.name'), description: [interventionData?.nombreProveedor || ''] }]} />
    </ProviderStyle>
  );
};

export default Provider;
